import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export interface ControlPlaneSectionProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  children: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  surface?: boolean;
}

export function ControlPlaneSection({
  children,
  title,
  description,
  actions,
  surface = false,
  className,
  ...rest
}: ControlPlaneSectionProps) {
  return (
    <section {...rest} className={clsx('vania-control-plane-section', surface && 'vania-control-plane-section--surface', className)}>
      {title || description || actions ? (
        <header className="vania-control-plane-section__header">
          <div>
            {title ? <h2>{title}</h2> : null}
            {description ? <p>{description}</p> : null}
          </div>
          {actions ? <div className="vania-control-plane-section__actions">{actions}</div> : null}
        </header>
      ) : null}
      <div className="vania-control-plane-section__content">{children}</div>
    </section>
  );
}
